import { CopyToClipboard } from "react-copy-to-clipboard";
import { LuCopy } from "react-icons/lu";
import { useAuthUser } from "../../../core_stores/useAuthStore";
import { typography } from "../../../design/tokens";
import { useSnackbar } from "../../../providers/SnackbarProvider";

export default function PersonalSettingsYourProfile() {
  return (
    <div>
      <div className="flex flex-col gap-6">
        <PersonalInfo />
        <UserId />
      </div>
    </div>
  );
}

function PersonalInfo() {
  const user = useAuthUser();

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div
          className="w-[50px] h-[50px]
                      rounded-full bg-primary-blue
            flex items-center justify-center
            text-white text-[40px] overflow-hidden"
        >
          <img
            src={user?.photoURL || ""}
            alt="User profile"
            className="w-full h-full object-cover"
            referrerPolicy="no-referrer"
          />
        </div>
        <div className="flex flex-col gap-1">
          <div className={`${typography.size.base} text-dark-text`}>
            {user?.displayName}
          </div>
          <div className={`${typography.size.sm} text-dark-placeholder`}>
            {user?.email}
          </div>
        </div>
      </div>
      {/* Hidden for now - Edit button will be needed when login methods that require editing are added (e.g. username/password authentication where users need the ability to change credentials) */}
      {/* <button className={components.button.primary}>
        <LuSquarePen size={14} />
        Edit
      </button> */}
    </div>
  );
}

function UserId() {
  const user = useAuthUser();
  const { showSnackbar } = useSnackbar();

  const handleCopy = () => {
    if (!user?.uid) {
      showSnackbar("User ID is not available", {
        type: "error",
      });
      return;
    }
    showSnackbar("User ID copied to clipboard");
  };

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex flex-col gap-1">
        <div className={`${typography.size.base} text-dark-text`}>User ID</div>
        <div className={`${typography.size.sm} text-dark-placeholder font-mono`}>
          {user?.uid}
        </div>
      </div>
      <CopyToClipboard text={user?.uid || ""} onCopy={handleCopy}>
        <button
          className="flex items-center justify-center
            text-dark-text
            border border-dark-border
            rounded-lg h-10 w-10
            hover:bg-dark-hover
            transition-colors duration-300"
          title="Copy ID"
        >
          <LuCopy size={20} />
        </button>
      </CopyToClipboard>
    </div>
  );
}
